import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from '../../../assets/images/blog/careers.png'

const Benefits = () => {
    return (
        <>
            <Breadcumb Title="Benefits" Breadcumb="CAREERS" BgImg={BgImg} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-title">
                                <p className="section-title__text">What you get</p>
                                <h2 className="section-title__title">We look after the people who do the work</h2>
                            </div>
                            <div className="about-four__text" style={{marginBottom: 20}}>
                                Great work comes from people who feel supported, trusted, and fairly rewarded. Our
                                benefits are built around three things: your flexibility, your growth, and your
                                well-being.
                            </div>
                            <div className="about-four__text" style={{marginBottom: 30}}>
                                Specific packages vary by country across our UK, Sweden, and Ghana hubs — we will walk
                                you through the details for your location during the hiring process.
                            </div>
                            <ul className="service-details__caption__list" style={{marginBottom: 40}}>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Competitive salary, reviewed regularly
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Hybrid and flexible working as standard
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    A yearly learning budget and time for courses, conferences, and certifications
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Modern equipment of your choice
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Team events and meet-ups across our hubs
                                </li>
                            </ul>
                            <Link to="/careers" className="thm-btn"><span>View Open Roles</span></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benefits
